import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaFacebookF, FaTwitter, FaSnapchatGhost } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './style/Footer.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="footer-content">

        {/* Menu */}
        <div className="footer-section">
          <h4>{t('footer.menu')}</h4>
          <ul>
            <li><Link to="/">{t('footer.home')}</Link></li>
            <li><Link to="/guides">{t('footer.guide')}</Link></li>
            <li><Link to="/Walloflove">{t('footer.wall')}</Link></li>
            <li><Link to="/Contacts">{t('footer.contacts')}</Link></li>
            <li><Link to="/Pricing">{t('footer.pricing')}</Link></li>
          </ul>
        </div>

                {/* Contact */}
        <div className="footer-section">
          <h4>{t('footer.Mentionslegales')}</h4>
          <ul>
            <li><Link to="/generalconditions">{t('footer.conditiongenerales')}</Link></li>
            <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
            <li><Link to="/cgv-cgu">{t('footer.cgvcgu')}</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <p>{t('footer.email')} : <a href="mailto:support@gevents.com">contact@beonwall.com</a></p>
        </div>

        {/* Réseaux sociaux */}
        <div className="footer-section">
          <h4>{t('footer.follow')}</h4>
          <div className="footer-socials">
            <a href="https://www.instagram.com/be.on.wall/" target="_blank" rel="noopener noreferrer">
              <FaInstagram aria-hidden="true"/>
            </a>
            <a href="https://www.tiktok.com/@beonwall?lang=fr" target="_blank" rel="noopener noreferrer">
              <FaTiktok aria-hidden="true"/>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61577303138826" target="_blank" rel="noopener noreferrer">
              <FaFacebookF aria-hidden="true"/>
            </a>
            <a href="https://x.com/Be_on_wall" target="_blank" rel="noopener noreferrer">
              <FaTwitter aria-hidden="true"/>
            </a>
            <a href="https://www.snapchat.com/add/beonwall" target="_blank" rel="noopener noreferrer">
              <FaSnapchatGhost aria-hidden="true" />
            </a>
          </div>
        </div>

      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} Be On Wall – {t('footer.rights')}
      </div>
    </footer>
  );
}

export default Footer;
